import { bubEvents } from 'javascripts/shared/events/bub_events';

require('waypoints/src/waypoint.js'); // eslint-disable-line import/extensions
require('waypoints/lib/noframework.waypoints.min.js'); // eslint-disable-line import/extensions

export class SiteConversionTrackingHelper {
  constructor(conversionElement, event, additionalProps = {}) {
    this.category = conversionElement;

    const baseTrackingProps = event ? { label: $(event.target).text() } : {};
    this.trackingProps = _.merge(baseTrackingProps, additionalProps);
  }

  trackConversion() {
    bubEvents.track(this.category, 'Clicked site signup element', this.trackingProps);
  }
}

export const SiteImpressions = {
  trackImmediately({ category, action, eventLabel, eventValue } = {}) {
    bubEvents.track(category, action, {
      label: eventLabel,
      value: eventValue,
    });
  },

  trackOnClick({ elementIdOrClass, category, action, eventLabel } = {}) {
    if ($(elementIdOrClass).length) {
      $(elementIdOrClass).click(() => {
        bubEvents.track(category, action, {
          label: eventLabel,
        });
      });
    }
  },

  trackWhenInView({ elementId, category, action, eventLabel, offset } = {}) {
    if (elementId.length) {
      // eslint-disable-next-line no-new
      new Waypoint({
        element: document.getElementById(elementId),
        handler(direction) {
          if (direction === 'down') {
            bubEvents.track(category, action, {
              label: eventLabel,
            });
            this.destroy();
          }
        },
        offset,
      });
    }
  },
};
